import type { TBasketItem } from '../types/basket-item.type';

/**
 * Получение количества единиц определенного товара из корзины
 * @param {TBasketItem[] | null} currentItems - массив товаров из корзины
 * @param {string} productCode - код товара
 * @returns {number} - количество единиц товара в корзине
 */
export const getProductQuantityInBasket = (currentItems: TBasketItem[] | null, productCode: string): number => {
  const products = currentItems instanceof Array ? [...currentItems] : [];

  const item = products.find(({ code }) => code === productCode);

  if (item) {
    return item.quantity;
  }

  return 0;
};
